export function initCursor(): void {
  const dot = document.getElementById("cursorDot");
  const ring = document.getElementById("cursorRing");
  if (!dot || !ring) return;

  if (!window.matchMedia("(hover: hover)").matches) {
    dot.style.display = "none";
    ring.style.display = "none";
    return;
  }

  let mx = window.innerWidth / 2;
  let my = window.innerHeight / 2;
  let rx = mx;
  let ry = my;

  window.addEventListener("mousemove", (e) => {
    mx = e.clientX;
    my = e.clientY;
    dot.style.transform = `translate(${mx}px, ${my}px) translate(-50%, -50%)`;
  });

  function tickRing(): void {
    rx += (mx - rx) * 0.18;
    ry += (my - ry) * 0.18;
    ring!.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
    requestAnimationFrame(tickRing);
  }
  tickRing();

  document
    .querySelectorAll<HTMLElement>(
      "a, button, .campaign-tile, .blueprint-row, .catalog-row",
    )
    .forEach((el) => {
      el.addEventListener("mouseenter", () => ring.classList.add("over-link"));
      el.addEventListener("mouseleave", () =>
        ring.classList.remove("over-link"),
      );
    });
}
